import { getCookie } from '@utils/cookies';

class HubSpotService {
  constructor() {
    this.trackingCode = process.env.VUE_APP_HUBSPOT_TRACKING_CODE;
    this.isLoaded = false;
    this.utmParams = this.extractUTMParams();
  }

  // Extract UTM parameters from URL
  // prioritize to get the utm params from cookies flashy_utm_utm_source, flashy_utm_utm_medium..., then from URL
  extractUTMParams() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {
      utm_source: params.get('utm_source') || getCookie('flashy_utm_utm_source'),
      utm_medium: params.get('utm_medium') || getCookie('flashy_utm_utm_medium'),
      utm_campaign: params.get('utm_campaign') || getCookie('flashy_utm_utm_campaign'),
      utm_term: params.get('utm_term') || getCookie('flashy_utm_utm_term'),
      utm_content: params.get('utm_content') || getCookie('flashy_utm_utm_content')
    };

    console.log('Extracted UTM parameters:', utmParams);
    return utmParams;
  }

  // Store UTM parameters in localStorage
  storeUTMParams() {
    if (Object.keys(this.utmParams).length > 0) {
      localStorage.setItem('hubspot_utm_params', JSON.stringify(this.utmParams));
      localStorage.setItem('hubspot_utm_timestamp', Date.now().toString());
    }
  }

  // Get stored UTM parameters
  getStoredUTMParams() {
    const stored = localStorage.getItem('hubspot_utm_params');
    const timestamp = localStorage.getItem('hubspot_utm_timestamp');

    console.log('Stored UTM parameters:', stored);
    // Check if UTM params are older than 30 days
    if (timestamp && Date.now() - parseInt(timestamp) > 30 * 24 * 60 * 60 * 1000) {
      this.clearStoredUTMParams();
      return {};
    }

    return stored ? JSON.parse(stored) : {};
  }

  // Clear stored UTM parameters
  clearStoredUTMParams() {
    localStorage.removeItem('hubspot_utm_params');
    localStorage.removeItem('hubspot_utm_timestamp');
  }

  // Initialize HubSpot tracking
  init() {
    if (!this.trackingCode || this.isLoaded) return;

    // Load HubSpot tracking script
    const script = document.createElement('script');
    script.src = `//js-na2.hs-scripts.com/${this.trackingCode}.js`;
    script.async = true;
    script.defer = true;
    script.id = 'hs-script-loader';

    script.onload = () => {
      this.storeUTMParams();
    };

    document.head.appendChild(script);
    this.isLoaded = true;
  }

  // Track page view with UTM parameters
  trackPageView(pageName) {
    if (!window._hsq) {
      window._hsq = [];
    }

    const utmData = { ...this.utmParams, ...this.getStoredUTMParams() };

    window._hsq.push(['setPath', window.location.pathname]);
    window._hsq.push(['trackPageView', pageName, utmData]);
  }

  // Track custom event
  trackEvent(eventName, properties = {}) {
    if (!window._hsq) {
      window._hsq = [];
    }

    const utmData = { ...this.utmParams, ...this.getStoredUTMParams() };
    const eventData = { ...properties, ...utmData };

    console.log(`Tracking event test: ${eventName}`, eventData);
    window._hsq.push([
      'trackEvent',
      {
        id: eventName,
        value: eventData
      }
    ]);
  }

  // Track form submission
  trackFormSubmission(formId, formData = {}) {
    if (!window._hsq) {
      window._hsq = [];
    }

    const utmData = { ...this.utmParams, ...this.getStoredUTMParams() };
    const submissionData = { ...formData, ...utmData };

    window._hsq.push([
      'trackEvent',
      {
        id: 'form_submission',
        value: {
          form_id: formId,
          ...submissionData
        }
      }
    ]);
  }

  // Get all UTM parameters for form submissions
  getUTMParamsForForms() {
    return { ...this.utmParams, ...this.getStoredUTMParams() };
  }
}

export default new HubSpotService();
